import React from 'react';
import styled from 'styled-components';

interface StyledButtonProps {
  disabled?: boolean;
}

const StyledButton = styled.button<StyledButtonProps>`
  background: transparent;
  color: #319aa6;
  border: none;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  transition: all 0.2s ease;
  min-width: 44px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

interface ButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const Button: React.FC<ButtonProps> = ({ onClick, disabled = false, title, children, style }) => {
  return (
    <StyledButton onClick={onClick} disabled={disabled} title={title} style={style}>
      {children}
    </StyledButton>
  );
};
